export default __webpack_public_path__ + "static/media/picgreen.f41b5690.png";